<template>
  <v-card style='text-align:left'>

    <v-layout col justify-start>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Service</label>
      </v-flex>
      <v-flex xs3 mx-2>
        <v-select  v-model="person.service" :items="serviceValues" single-line></v-select>
      </v-flex>
    </v-layout>

    <v-layout row v-if="!person.serviceNum || (person.serviceNum.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Service Number</label><v-btn flat fab  small mt-4  middle @click='addMultiOccuringProp("serviceNum", -1, {v: ""})'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Service Number</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row justify-start v-for="(serviceNum, index) in person.serviceNum" v-bind:key="serviceNum.rid">
          <v-flex xs8 mx-2>
            <v-text-field v-focus autofocus single-line v-model="person.serviceNum[index].v"/>
 
            <template v-if="serviceNum.scopeFrom || serviceNum.scopeTo">
              Start <input type="date" v-model="serviceNum.scopeFrom"/> End <input type="date" v-model="serviceNum.scopeTo"/>         
              <v-icon  small  @click='delDateRange("serviceNum", index)' >delete</v-icon>
            </template>
          </v-flex>
          <v-flex xs4 pt-3   >       
            <v-icon  small  @click='delProp("serviceNum", index)' >delete</v-icon>
            <v-icon  small @click='addMultiOccuringProp("serviceNum", index, {v: ""})'>add</v-icon>
            <v-icon v-if="index > 0"  small   @click='up(person.serviceNum, index)'>arrow_upward</v-icon>
            <v-icon v-if="index < (person.serviceNum.length - 1)"  small  @click='down(person.serviceNum, index)'>arrow_downward</v-icon>
            <v-icon v-if="!(serviceNum.scopeFrom || serviceNum.scopeTo)"  small  @click='addDateRange("serviceNum", index)'>date_range</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>   

    <v-layout row v-if="!person.servicePlace || (person.servicePlace.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Service Place Summary</label><v-btn flat fab  small mt-4  middle @click='addMultiOccuringProp("servicePlace", -1, {})'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Service Place Summary</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row justify-start v-for="(servicePlace, index) in person.servicePlace" v-bind:key="servicePlace.rid">
          <v-flex xs8 mx-2>
            <EditServicePlace v-bind:servicePlace='servicePlace' v-bind:person='person'/>
          </v-flex>
          <v-flex xs4 pt-3   >       
            <v-icon  small  @click='delProp("servicePlace", index)' >delete</v-icon>
            <v-icon  small @click='addMultiOccuringProp("servicePlace", index, {})'>add</v-icon>
            <v-icon v-if="index > 0"  small   @click='up(person.servicePlace, index)'>arrow_upward</v-icon>
            <v-icon v-if="index < (person.servicePlace.length - 1)"  small  @click='down(person.servicePlace, index)'>arrow_downward</v-icon>           
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>  

    <v-layout row v-if="!person.servicePeriod || (person.servicePeriod.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Service Period Summary</label><v-btn flat fab  small mt-4  middle @click='addMultiOccuringProp("servicePeriod", -1, {service: "AIF"})'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Service Period Summary</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row justify-start v-for="(servicePeriod, index) in person.servicePeriod" v-bind:key="servicePeriod.rid">
          <v-flex xs8 mx-2>
            <EditServicePeriod v-bind:servicePeriod='servicePeriod' v-bind:person='person'/>
          </v-flex>
          <v-flex xs4 pt-3   >       
            <v-icon  small  @click='delProp("servicePeriod", index)' >delete</v-icon>
            <v-icon  small @click='addMultiOccuringProp("servicePeriod", index, {service: "AIF"})'>add</v-icon>
            <v-icon v-if="index > 0"  small   @click='up(person.servicePeriod, index)'>arrow_upward</v-icon>
            <v-icon v-if="index < (person.servicePeriod.length - 1)"  small  @click='down(person.servicePeriod, index)'>arrow_downward</v-icon>           
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row v-if="!person.serviceDays || (person.serviceDays.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Service Days Summary</label><v-btn flat fab  small mt-4  middle @click='addMultiOccuringProp("serviceDays", -1, createServiceDays(0))'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Service Days Summary</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row justify-start v-for="(serviceDays, index) in person.serviceDays" v-bind:key="serviceDays.rid">
          <v-flex xs8 mx-2>
            <EditServiceDays v-bind:serviceDays='serviceDays' v-bind:person='person'/>
          </v-flex>
          <v-flex xs4 pt-3   >       
            <v-icon  small  @click='delProp("serviceDays", index)' >delete</v-icon>
            <v-icon  small @click='addMultiOccuringProp("serviceDays", index, createServiceDays(index+1))'>add</v-icon>
            <v-icon v-if="index > 0"  small   @click='up(person.serviceDays, index)'>arrow_upward</v-icon>
            <v-icon v-if="index < (person.serviceDays.length - 1)"  small  @click='down(person.serviceDays, index)'>arrow_downward</v-icon>           
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row v-if="!person.bio || (person.bio.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Service History</label><v-btn flat fab  small mt-4  middle @click='addMultiOccuringProp("bio", -1, {beTemplateId: -1})'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Service History</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row justify-start v-for="(bio, index) in person.bio" v-bind:key="bio.rid">
          <v-flex xs8 mx-2>
            <EditBio v-bind:bio='bio' v-bind:person='person'/>
          </v-flex>
          <v-flex xs4 pt-3   >       
            <v-icon  small  @click='delProp("bio", index)' >delete</v-icon>
            <v-icon  small @click='addMultiOccuringProp("bio", index, generateBioForIndex(index))'>add</v-icon>
            <v-icon v-if="index > 0"  small   @click='up(person.bio, index)'>arrow_upward</v-icon>
            <v-icon v-if="index < (person.bio.length - 1)"  small  @click='down(person.bio, index)'>arrow_downward</v-icon>           
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>  

    <v-layout row v-if="!person.unit">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Final Unit</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("unit", {rid: -1})'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Final Unit</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-autocomplete  v-focus autofocus v-model="fu.select" :items="fu.units" item-text="name" item-value="id"
          :search-input.sync="fuSearch" :loading="fu.loading" single-line  return-object>     
        </v-autocomplete>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("unit")'>delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 

    <v-layout row v-if="!person.rank">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Final Rank</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("rank", {rid: -1})'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Final Rank</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-autocomplete  v-focus autofocus v-model="fr.select" :items="fr.ranks" item-text="name" item-value="id"
          :search-input.sync="frSearch" :loading="fr.loading" single-line  return-object>     
        </v-autocomplete>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("rank")'>delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>   

    <v-layout row v-if="!person.homePort">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Home Port</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("homePort", {rid: -1})'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Home Port</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-autocomplete  v-focus autofocus v-model="homePort.select" :items="homePort.places" item-text="pn" item-value="id"
          :search-input.sync="homePortSearch" :loading="homePort.loading" single-line  return-object  @change="homePortChange()">     
        </v-autocomplete>
        <v-layout row v-if="person.homePort.extra">
          <v-flex xs10>
              <v-text-field v-model="person.homePort.extra" label="Street/Locality"/>
          </v-flex>
          <v-flex xs2>
              <v-icon  small  @click='delPlaceExtra("homePort")' >delete</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("homePort")'>delete</v-icon>
        <v-icon v-if="(!person.homePort.extra)"  small  @click='addPlaceExtra("homePort")'>place</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>    

<!-- 4jul21 - finally remove honour from here - they are MEANT to be added as part of service history
    <v-layout row v-if="!person.honour || (person.honour.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Honour</label><v-btn flat fab  small mt-4  middle @click='addMultiOccuringProp("honour", -1, null, "aw", "Victoria Cross")'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Honour</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row justify-start v-for="(honour, index) in person.honour" v-bind:key="honour.rid">
          <v-flex xs8 mx-2>
            <v-autocomplete v-focus autofocus v-model="person.honour[index]" :items="$constants.codeValues.aw" item-text="v" item-value="id" return-object single-line>
            </v-autocomplete>  
            <template v-if="honour.scopeFrom || honour.scopeTo">
              Start <input type="date" v-model="honour.scopeFrom"/> End <input type="date" v-model="honour.scopeTo"/>         
              <v-icon  small  @click='delDateRange("honour", index)' >delete</v-icon>
            </template>
          </v-flex>
          <v-flex xs4 pt-3   >       
            <v-icon  small  @click='delProp("honour", index)' >delete</v-icon>
            <v-icon  small @click='addMultiOccuringProp("honour", index, null, "aw", "Victoria Cross")'>add</v-icon>
            <v-icon v-if="index > 0"  small   @click='up(person.honour, index)'>arrow_upward</v-icon>
            <v-icon v-if="index < (person.honour.length - 1)"  small  @click='down(person.honour, index)'>arrow_downward</v-icon>
            <v-icon v-if="!(honour.scopeFrom || honour.scopeTo)"  small  @click='addDateRange("honour", index)'>date_range</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    -->

    <v-layout row v-if="!person.pow">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Prisoner of War</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("pow", "y")'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Prisoner of War</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2 mt-3>
          Yes 
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("pow")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>  

    <!-- moved to bio: v-layout row v-if="!person.dischargeDate">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Discharge Date</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("dischargeDate", "1945-06-30")'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Discharge Date</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2 mt-3>
          <input type="date" v-model="person.dischargeDate"/> 
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("dischargeDate")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>    
    </v-layout -->       

    <v-layout row v-if="!person.returnToAustraliaDate">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Returned to Australia Date</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("returnToAustraliaDate", "1945-06-30")'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Returned to Australia Date</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2 mt-3>
          <input type="date" v-focus autofocus v-model="person.returnToAustraliaDate"/> 
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("returnToAustraliaDate")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>    
    </v-layout> 

  </v-card>
</template>        

<script>

import UnitService from "@/services/UnitService" ;
import RankService from "@/services/RankService" ;
import EditBio from "./EditBio" ; 
import EditServicePlace from "./EditServicePlace" ;
import EditServicePeriod from "./EditServicePeriod" ;
import EditServiceDays from "./EditServiceDays" ;

export default {

  components: { UnitService, EditBio, EditServicePlace, EditServicePeriod, EditServiceDays },
  props: {
    person: null
  },

  data () {
    return {
      addSeqForRid: -1,
      fu: {
        select: {id: -1, name: "", count: -1}, 
        units: [],
        loading: false,
        origId: -1,
        nextSearchFor: null
      },
      fuSearch: null,

      fr: {
        select: {id: -1, name: "", count: -1}, 
        ranks: [],
        loading: false,
        origId: -1,
        nextSearchFor: null
      },
      frSearch: null,
      serviceValues: ['Army', 'Merchant Navy', 'RAAF', 'RAN'],
      rankCodesForService: ['ra', 'rc', 'rd', 'rb'],

      homePort: {
        select: {id: -1, pn: ""}, 
        places: [],
        loading: false,
        origId: -1,
        placeRelType: 'pp',
        nextSearchFor: null
      },
      homePortSearch: null  
    }
  },

  watch: {
    async fuSearch (val) {
      console.log("IN FU SEARCH val: " + val + ", this.fu.Select.name=" + this.fu.select.name) ;
      if (val && val !== this.fu.select.name && (val.length >= 2)) {
        this.unitQuerySelections(val, this.fu) ;
      }
    }, 
    async frSearch (val) {
      console.log("IN FR SEARCH val: " + val + ", this.fr.Select.name=" + this.fr.select.name) ;
      if (val && val !== this.fr.select.name && (val.length >= 2)) {
        this.rankQuerySelections(val, this.fr) ;
      }
    },
    async homePortSearch (val) {
      if (val && val !== this.homePort.select.pn && (val.length >= 2)) 
        this.error = this.$placeQuerySelections(val, this.homePort) ;      
    },   
    
    person: function (val) {
      // this.person = val ;
      this.updateFU() ;
      this.updateFR() ;
      this.$updatePlaceSelectionFromRecord(this.homePort, this.person.homePort) ;
    }    
  },

  methods: {

    generateBioForIndex (index) {
      const prevBio = this.person.bio[index] ;
      return (prevBio && prevBio.date) ? {beTemplateId: -1, date: prevBio.date} : {beTemplateId: -1} ;
    },

    updateFU () {

      console.log("Service tab in updateFU") ;
      this.updateUnit(this.fu, this.person.unit) ;
    },

    updateUnit (locp, dbu) {

      if (dbu && dbu.rid) {  // todo
        locp.select.id = dbu.id ; 
        locp.select.name = dbu.v ;
        
        locp.origId =  locp.select.id ;
        locp.units = [ locp.select ] ;
        console.log("Set locp units=" + JSON.stringify(locp.units)) ;
      }
    },

    updateFR () {

      console.log("Service tab in updateFR") ;
      this.updateRank(this.fr, this.person.rank) ;
    },

    updateRank (locp, dbr) {

      if (dbr && dbr.rid) {  // todo
        locp.select.id = dbr.id ; 
        locp.select.name = dbr.v ;
        
        locp.origId =  locp.select.id ;
        locp.ranks = [ locp.select ] ;
        console.log("Set locp units=" + JSON.stringify(locp.ranks)) ;
      }
    },    

    finaliseUpdates () {

      console.log("===========================> servicetab finaliseUpdates fu: " +
        this.fu.origId  + " - " + this.fu.select.id + " unit=" + JSON.stringify(this.person.unit)) ;
      // check the unit
      if (this.person.unit && (this.fu.origId !==  this.fu.select.id)) {  // changed (and not just deleted)
        console.log("Set fu newId..") ;
        this.person.unit.newId = this.fu.select.id ; // will force updater to do the work of rebuilding - we dont worry about town/state/country ids
      }
      // check the rank
      if (this.person.rank && (this.fr.origId !==  this.fr.select.id)) {  // changed (and not just deleted)
        console.log("Set fr newId..") ;
        this.person.rank.newId = this.fr.select.id ; // will force updater to do the work of rebuilding - we dont worry about town/state/country ids
      }      
    },

    homePortChange () {
      console.log("---------------------------------homePortChange: " + JSON.stringify(this.homePort.select)) ;
      this.person.homePort.newId = this.homePort.select.id ;
    },

    async unitQuerySelections (val, locp) {

      console.log("unitQuerySelections val: " + val) ;
      locp.loading = true ;
      try {
        const response = await UnitService.index(val, 0, 1000) ;
        console.log("UnitService responsed") ; // + JSON.stringify(response)) ;

        const d = response.data ;
        for (let i = 0 ; i < d.length ; i++) {
          const du = d[i] ;
          du.name += " - " + du.count + ((du.count === 1) ? " person" : " people") ;
        }
        locp.units = response.data ;
      }
      catch (err) {
        console.log("unitQuerySelections catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
      }
      finally {
        locp.loading = false ;
      }
    },

    async rankQuerySelections (val, locp) {

      const ix = this.serviceValues.indexOf(this.person.service) ;
      const serviceCode = (ix >= 0) ? this.rankCodesForService[ix] : null ;

      console.log("rankQuerySelections val: " + val + " serviceCode " + serviceCode) ;
      locp.loading = true ;
      try {
        const response = await RankService.index(val, serviceCode, 0, 1000) ;
        console.log("RankService responsed " + JSON.stringify(response)) ;

        const d = response.data ;
        for (let i = 0 ; i < d.length ; i++) {
          const dr = d[i] ;
          dr.name += " - " + dr.count + ((dr.count === 1) ? " person" : " people") ;
        }
        locp.ranks = response.data ;
      }
      catch (err) {
        console.log("rankQuerySelections catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
      }
      finally {
        locp.loading = false ;
      }
    },    

    needed (value) {
      console.log(" in needed, value is " + value)  ;
      if (value && value.length && (value.length > 0)) return true ;
      this.$emit('errorOnTab') ; 
      console.log("emmitted swap") ;
      return "Required" ;
    },

    addMultiOccuringProp (propName, index, record, propCode, defaultValue) {  // addMultiOccuringProp("otherNames", -1, {surname: "", firstNames: ""})

      if (!this.person[propName]) this.person[propName] = [] ;
      var newRec ;
      if (record) newRec = { ...record, rid: this.addSeqForRid-- } ; // a unique rid so as not to confuse keys - but it will be negative, so backend knows it is new
      else  {
        newRec = {...this.setDefaultOption(propCode, defaultValue), rid: this.addSeqForRid--} ;
      }
      
      console.log("in addMultiOccuringProp " + record + " newRec " + JSON.stringify(newRec)) ;

      this.person[propName].splice(index + 1, 0, newRec) ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    addDateRange (propName, index) {
      console.log("adding date range to " + propName + " at " + index) ;
      this.person[propName][index].scopeFrom = "1900-01-01" ;
      this.person[propName][index].scopeTo = "1900-12-31" ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    delDateRange (propName, index) {
      console.log("adding date range to " + propName + " at " + index) ;
      delete this.person[propName][index].scopeFrom  ;
      delete this.person[propName][index].scopeTo ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    addPlaceExtra (propName) {
      console.log("adding placeextra to " + propName) ;
      this.person[propName].extra = " " ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    delPlaceExtra (propName) {
      console.log("adding placeextra to " + propName) ;
      delete this.person[propName].extra ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    }, 

    up (arr, ix) {  // take entry at ix and move it to ix-1
      console.log("UpA " + ix + "  arr:" + JSON.stringify(this.person.otherNames)) ; 
      var x = arr[ix] ;
      arr[ix] = arr[ix - 1] ;
      arr[ix - 1] = x ;
      console.log("UpB " + ix + "  arr:" + JSON.stringify(this.person.otherNames)) ; 
      this.$forceUpdate() ;

    },
    down (arr, ix) {
      console.log("downA " + ix + "  arr:" + JSON.stringify(arr)) ; 
      var x = arr[ix] ;
      arr[ix] = arr[ix + 1] ;
      arr[ix + 1] = x ;
      console.log("downB " + ix + "  arr:" + JSON.stringify(arr)) ; 
      this.$forceUpdate() ;
    },

    setDefaultOption (codeType, defaultValue) {
      const glist = this.$constants.codeValues[codeType] ; 
      for (var i = 0 ; i < glist.length ; i++) {
        if (glist[i].v === defaultValue) {
          return { v: glist[i].v, id: glist[i].id } ;
        }
      }
      return { v: "No default", id: -1 } ;
    },

    delProp (propName, index) {
      console.log("Del prop name " + propName + " index " + index) ;
      if (index >= 0) this.person[propName].splice(index, 1) ;
      else delete this.person[propName] ;
      this.$forceUpdate() ;
    },

    addSinglyOccuringNoncodeProp (propName, defaultValue) {
      this.person[propName] = defaultValue ;
      this.$forceUpdate() ;   // shouldnt have to do this..
    },

    addSinglyOccuringCodeProp (propName, propCode, defaultValue) {  
      this.person[propName] = [ this.setDefaultOption(propCode, defaultValue) ] ;
      this.$forceUpdate() ;   // shouldnt have to do this..
    },

    createServiceDays (newIndex) {
      let ix = newIndex ;
      if (ix < 0) ix = 0 ;
      if (ix >= this.$dayTypes.length) ix = this.$dayTypes.length - 1 ;
      return { type: this.$dayTypes[ix].value, days: null } ;
    }
  } 
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Person/ServiceTab.vue